<template>
    <el-dialog title="Type de produit" v-loading="loader" :visible.sync="display" top="1vh" width="80%">
        <div class="mb-3">Modifier les {{ items_selected }} produits selectionnés</div>
        <div class="ctn-limit-height">
            <el-form>
                <product-edit-features :product="form.product"></product-edit-features>
            </el-form>

        </div>
        <span slot="footer" class="dialog-footer">
            <el-switch active-text="Conserver le type de produit ?" v-model="form.keep_type"></el-switch>
            <el-switch active-text="Supression des features sélectionnées ?" v-model="form.remove" :disabled="form.overide"></el-switch>
            <el-switch active-text="Syncronisé ?" v-model="form.sync" ></el-switch>
            <el-switch active-text="Remplacer images ?" v-model="form.override_images" ></el-switch>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            featureOptions: [],
            form: {
                product: {
                    types_product_id: [],
                    featuresIds: []
                },
                feature_value_id: null,
                keep_type: true,
                overide: false,
                remove: false,
                sync: false,
                override_images: false,
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.form.product.featuresIds = [];
            this.form.product.types_product_id = [];
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            if (!this.form.product.featuresIds.length) {
                return;
            }
            var text = 'Ajouter les features ?';
            if( this.form.remove ) {
                text = 'Supprimé les features sélectionnées des produits ?';
            }
            if( this.form.overide ) {
                text = 'Remplacé les features sélectionnées des produits ?';
            }
            this.$confirm(text, 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    var products = this.selected.map(v => v.id);
                    this.loader = true;
                    var datas = {
                        products,
                        remove: this.form.remove,
                        overide: this.form.overide,
                        keep_type: this.form.keep_type,
                        features: this.form.product.featuresIds,
                        sync: this.form.sync,
                        override_images: this.form.override_images,
                        mode: 'product_type'
                    };
                    if (this.applyToAllResult) {
                        datas.filters = this.filters;
                    }
                    datas.total_item = this.total_item
                    datas.items_selected = this.items_selected
                    axios
                        .post('/products/bulk', datas)
                        .then(r => {
                            this.$emit('saved', r);
                            this.form.product.featuresIds = [];
                            this.form.product.types_product_id = [];
                            this.form.remove = false
                            this.form.overide = false
                            this.form.override_images = false
                            this.form.sync = false
                            this.display = false;
                        })
                        .catch(() => {})
                        .then(() => {
                            this.loader = false;
                        });
                }).catch(()=>{})


        },
    }
};
</script>
